var chunkMapping = {
	"9030": [
		39030
	]
};
var idToExternalAndNameMapping = {
	"39030": [
		"default",
		"./PosLocator",
		71763
	]
};
var idToRemoteMap = {
	"39030": [
		{
			"externalType": "script",
			"name": "HCIDPosLocator",
			"externalModuleId": 71763
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}